import React from 'react'
import { SvgIcon, SxProps } from '@mui/material'

interface Props {
  sx?: SxProps
  [prop: string]: any
}

export const TribuneWappIcon = ({ sx, ...props }: Props) => (
  <SvgIcon
    viewBox="0 0 24 24"
    sx={{ width: '24px', height: '24px', ...sx }}
    {...props}
  >
    <path
      fill="url(#tribuneId)"
      fillRule="evenodd"
      d="M16.989 20.872a.51.51 0 0 0-.5-.5h-.38l.73-6.55a.5.5 0 0 1 .5-.44 2 2 0 0 0 2-1.58l.66-3.14a1.19 1.19 0 0 0 0-.46 1.07 1.07 0 0 0-.56-.69 1 1 0 0 0-.44-.1h-9.38v-.1a3.79 3.79 0 0 1 1.44-2.83 1 1 0 0 0 1.49.15 1.54 1.54 0 1 0-1.65-2.56c-.72.46-.75.88-.52 1.37-.293.232-.573.48-.84.74a4.28 4.28 0 0 0-1.33 3v.17h-3.2a1 1 0 0 0-.79.38c-.1.12-.17.26-.21.41a.9.9 0 0 0 0 .46l.66 3.14a2 2 0 0 0 2 1.58.51.51 0 0 1 .5.44l.73 6.55h-.38a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9c.55 0 .49-.43.5-1l-.03-.44Zm-7.15-.9-.67-6a.5.5 0 0 1 .49-.55h4.66a.5.5 0 0 1 .49.55l-.67 6a.5.5 0 0 1-.49.44h-3.32a.5.5 0 0 1-.49-.44Zm-2.29-8.55a1 1 0 0 1-1-.76l-.28-1.25h11.44l-.31 1.25a1.07 1.07 0 0 1-.37.56 1 1 0 0 1-.63.2h-8.85Z"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="tribuneId"
        x1="12"
        x2="12"
        y1="1.688"
        y2="22.41"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#96C93D" />
        <stop offset="1" stopColor="#00B09B" />
      </linearGradient>
    </defs>
  </SvgIcon>
)

TribuneWappIcon.defaultProps = {
  sx: null,
}
